export class EndpointsConstants {
  public static AUTH_ENDPOINT = "/oauth2/code/auth";
  public static SAVE_TERMS_ENDPOINT = "/save-terms";
  public static FETCH_TERMS_ENDPOINT = "/terms-status";
  public static VERIFY_TOKEN_ENDPOINT = "/verifyToken";
  public static FETCH_ENTITLEMENTS_ENDPOINT = "/fetchUserEntitlements";
  public static METADATA_ENDPOINT = "/metadata.json";
}

export class CapacitorPreferencesConstants {
  public static LAST_SOFT_UPDATE = "lastSoftUpdate";
  public static IS_LOGIN_COMPLETE = "isLoginComplete";
  public static FIREBASE_TOKEN = "firebaseToken";
  public static FCM_TOKEN_NEEDS_SYNC = "fcm_token_needs_sync";
  public static ACCESS_TOKEN = "accessToken";
  public static ORDERBOOK_MODAL_ORDERID = "OrderBookViewModalOpen_orderId";
  public static MARKETDATA_MODAL_INSTRUMENT_ID =
    "MarketDataOverviewModalOpen_insId";
  public static OPTIONS_GRID_TSCODE = "OptionsGridViewModalOpen_tsCode";
  public static OPTIONS_GRID_STRIKE = "OptionsGridViewModalOpen_strike";
  public static MARKET_DATA_GRID_ID = "MarketDataSelectedGridId";
  public static TRADING_GRID_LIVE_PREF_FLAG = "tradingGridLiveFlagPref";
  public static BEACON_ACCESS = "beaconAccess";
}

export class MetricConstants {
  public static ORDER_HOLD_LATENCY = "cmedmobile.order.hold.roundtriptime";
  public static ORDER_HOLD_ALL_LATENCY =
    "cmedmobile.order.hold.all.roundtriptime";
  public static ORDER_ENTRY_LATENCY = "cmedmobile.order.entry.roundtriptime";
  public static ORDER_KILL_LATENCY = "cmedmobile.order.kill.roundtriptime";
  public static ORDER_KILL_ALL_LATENCY =
    "cmedmobile.order.kill.all.roundtriptime";
  public static ORDER_ACTIVATE_LATENCY =
    "cmedmobile.order.activate.roundtriptime";
  public static ORDER_MODIFY_LATENCY = "cmedmobile.order.modify.roundtriptime";
  public static TIME_TO_FIRST_PAINT_LOGIN =
    "cmedmobile.time.to.first.paint.login";
  public static TIME_TO_FIRST_PAINT_RECONNECTING_STATE_CHANGE =
    "cmedmobile.time.to.first.paint.reconnecting.state.change"; // 2 types
  public static TIME_TO_FIRST_PAINT_RECONNECTING_NETWORK =
    "cmedmobile.time.to.first.paint.reconnecting.network"; // 2 types
  public static SET_ALERT = "cmedmobile.alert.set";
  public static EDIT_ALERT = "cmedmobile.alert.edit";
  public static DELETE_ALERT = "cmedmobile.alert.delete";
  public static PAUSE_ALERT = "cmedmobile.alert.pause";
  public static RESUME_ALERT = "cmedmobile.alert.resume";
  public static SET_ALERT_SUCCESS = "cmedmobile.alert.set.success";
  public static EDIT_ALERT_SUCCESS = "cmedmobile.alert.edit.success";
  public static DELETE_ALERT_SUCCESS = "cmedmobile.alert.delete.success";
  public static PAUSE_ALERT_SUCCESS = "cmedmobile.alert.pause.success";
  public static RESUME_ALERT_SUCCESS = "cmedmobile.alert.resume.success";
  public static SET_ALERT_FAILURE = "cmedmobile.alert.set.failure";
  public static EDIT_ALERT_FAILURE = "cmedmobile.alert.edit.failure";
  public static DELETE_ALERT_FAILURE = "cmedmobile.alert.delete.failure";
  public static PAUSE_ALERT_FAILURE = "cmedmobile.alert.pause.failure";
  public static RESUME_ALERT_FAILURE = "cmedmobile.alert.resume.failure";
  public static CONTRACTS_FETCH_LATENCY =
    "cmedmobile.contracts.fetch.roundtriptime";
  public static POSITIONS_LOAD_LATENCY =
    "cmedmobile.positions.load.roundtriptime";
}

export class MetricTypeConstants {
  public static TIMER = "timer";
  public static GAUGE = "gauge";
  public static COUNTER = "counter";
  public static HISTOGRAM = "histogram";
}

export class UrlConstants {
  public static CMED_MOBILE_APP_STORE_LINK =
    "https://apps.apple.com/app/cmed-mobile/id6654917516";
  public static CMED_MOBILE_GOOGLE_PLAY_STORE_LINK =
    "https://play.google.com/store/apps/details?id=com.cme.one.cmedmobile";
}

export class AppThemes {
  public static DARK = "dark";
  public static LIGHT = "light";
  public static DEFAULT = "default";
}
